<div class="country-setup">
  <div class="country-setup-intro">
    <h4 class="country-setup-heading">
      {{ 'PROFILE.COUNTRY-SETUP.HEADING' | translate }}
    </h4>
    <p class="country-setup-subheading">
      {{ 'PROFILE.COUNTRY-SETUP.SUBHEADING' | translate }}
    </p>
  </div>

  <ul class="country-list">
    <li class="country-list-item" *ngFor="let country of countries">
      <div class="country-info">
        <img
          class="country-flag"
          alt="{{ country?.country_code }}"
          src="https://purecatamphetamine.github.io/country-flag-icons/3x2/{{ country?.country_code }}.svg"
        />
        <span class="country-name">{{ country?.name }}</span>
      </div>
      <span
        class="country-status"
        [ngClass]="isActive(country) ? 'country-status-active' : 'country-status-inactive'"
      >
        {{ (isActive(country) ? 'PROFILE.COUNTRY-SETUP.ACTIVE' : 'PROFILE.COUNTRY-SETUP.INACTIVE') | translate }}
      </span>
    </li>
  </ul>

  <button
    nz-button
    class="country-setup-btn"
    nzType="primary"
    nzSize="large"
    (click)="openCountrySetup()"
  >
    <i nz-icon nzType="plus"></i>
    {{ 'PROFILE.COUNTRY-SETUP.SETUP_BTN' | translate }}
  </button>
</div>

<!-- SHARED EXAM COUNTRY SETUP MODAL -->
<app-exam-country-setup
  *ngIf="examCountrySetupModal"
  [variant]="'verifier'"
  (closeModal)="closeCountrySetup()"
></app-exam-country-setup>
